/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ priority: NonNullable<unknown> }} Toast_Priority_SetInputs */

const en_toast_priority_set = /** @type {(inputs: Toast_Priority_SetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Priority set to ${i?.priority}`)
};

const de_toast_priority_set = /** @type {(inputs: Toast_Priority_SetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Priorität auf ${i?.priority} gesetzt`)
};

/**
* | output |
* | --- |
* | "Priority set to {priority}" |
*
* @param {Toast_Priority_SetInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const toast_priority_set = /** @type {((inputs: Toast_Priority_SetInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Priority_SetInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_toast_priority_set(inputs)
	return en_toast_priority_set(inputs)
});